import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "yingyangFilled"
const YingyangFilledIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M12.724 1.125C13.93 1.125 14.858 2.186 14.698 3.38L13.934 9.086 17.668 10.036C19.12 10.386 20.16 11.647 20.243 13.124L20.25 13.125V15.032H20.248C20.232 19.57 16.547 22.5 12 22.5 7.703 22.5 4.175 19.215 3.787 15.019V13.875C3.787 13.357 4.207 12.938 4.725 12.938H11.995L12.02 12.939Q12.058 12.941 12.13 12.954C12.23 12.973 12.355 13.01 12.475 13.076 12.677 13.19 12.938 13.427 12.938 14.062 12.938 14.631 12.728 14.873 12.558 14.996 12.355 15.14 12.114 15.179 12.018 15.186 11.98 15.189 11.915 15.194 11.846 15.206L7.408 15.944 7.592 17.055 9.622 16.716C10.015 17.037 10.347 17.445 10.593 17.92 10.899 18.513 11.062 19.187 11.062 19.875H12.189C12.188 19.011 11.983 18.159 11.59 17.402 11.42 17.073 11.215 16.768 10.983 16.489L12.03 16.315 12.106 16.307C12.292 16.293 12.77 16.23 13.215 15.91 13.693 15.565 14.063 14.975 14.063 14.062 14.063 13.012 13.573 12.405 13.026 12.097 12.771 11.952 12.521 11.883 12.338 11.848Q12.198 11.823 12.11 11.818L12.038 11.813H12.001L12 12.096V11.812H6.84C6.732 11.64 6.645 11.45 6.59 11.243L4.586 3.768C4.292 2.668 4.945 1.537 6.045 1.242S8.276 1.601 8.57 2.702L10.038 8.176 10.75 2.852C10.884 1.863 11.727 1.125 12.724 1.125" />
        </svg>
      }
    </span>
  )
}
export default YingyangFilledIcon
